import React, { useState, useEffect } from "react";

const fmt2  = (n) => Number(n||0).toFixed(2);
const fmtUSD = (n) => `$${fmt2(n)}`;
const authH  = () => ({ Authorization:`Bearer ${localStorage.getItem("access_token")||localStorage.getItem("token")||""}` });

const STATUS_STYLE = {
  pending:      { bg:"#f59e0b22", color:"var(--warning)",  label:"Pending" },
  under_review: { bg:"#3b82f622", color:"var(--accent)",  label:"Under Review" },
  paid:         { bg:"#10b98122", color:"var(--success)",  label:"Paid" },
  rejected:     { bg:"#ef444422", color:"var(--danger)",  label:"Rejected" },
  void:         { bg:"#6b728022", color:"var(--text-muted)",  label:"Void" },
  overdue:      { bg:"#ef444422", color:"var(--danger)",  label:"Overdue" },
};

const Badge = ({s}) => {
  const st = STATUS_STYLE[s] || STATUS_STYLE.pending;
  return <span style={{background:st.bg,color:st.color,padding:"2px 8px",borderRadius:20,
    fontSize:11,fontWeight:700,border:`1px solid ${st.color}44`}}>{st.label}</span>;
};

export default function AdminInvoices() {
  const [invoices, setInvoices] = useState([]);
  const [summary,  setSummary]  = useState({});
  const [filter,   setFilter]   = useState("under_review");
  const [loading,  setLoading]  = useState(true);
  const [selected, setSelected] = useState(null);
  const [action,   setAction]   = useState(null); // {type:'confirm'|'reject', inv}
  const [reason,   setReason]   = useState("");
  const [working,  setWorking]  = useState(false);
  const [toast,    setToast]    = useState(null);

  const showToast = (msg, ok=true) => {
    setToast({msg,ok}); setTimeout(()=>setToast(null),4000);
  };

  const load = () => {
    setLoading(true);
    const qs = filter ? `?status=${filter}` : "";
    fetch(`/api/admin/invoices${qs}`, { headers:authH() })
      .then(r=>r.json())
      .then(d=>{ if(d.ok){ setInvoices(d.invoices||[]); setSummary(d.summary||{}); } })
      .finally(()=>setLoading(false));
  };

  useEffect(()=>{ load(); }, [filter]);

  const confirmPaid = async (inv) => {
    setWorking(true);
    const r = await fetch(`/api/admin/invoices/${inv.id}/confirm-paid`, {
      method:"POST", headers:{...authH(),"Content-Type":"application/json"},
      body: JSON.stringify({ notes:"Admin confirmed" })
    }).then(r=>r.json());
    setWorking(false);
    if (r.ok) { showToast("Invoice confirmed as paid "); setAction(null); load(); }
    else showToast(r.error||"Failed", false);
  };

  const rejectInv = async (inv) => {
    if (!reason.trim()) { showToast("Rejection reason required", false); return; }
    setWorking(true);
    const r = await fetch(`/api/admin/invoices/${inv.id}/reject`, {
      method:"POST", headers:{...authH(),"Content-Type":"application/json"},
      body: JSON.stringify({ reason })
    }).then(r=>r.json());
    setWorking(false);
    if (r.ok) { showToast("Invoice rejected"); setAction(null); setReason(""); load(); }
    else showToast(r.error||"Failed", false);
  };

  const FILTERS = [
    {v:"under_review", label:`Under Review ${summary.under_review>0?`(${summary.under_review})`:""}` },
    {v:"pending",      label:`Pending ${summary.pending>0?`(${summary.pending})`:""}` },
    {v:"paid",         label:"Paid" },
    {v:"",             label:"All" },
  ];

  return (
    <div style={{padding:"20px 0"}}>
      {toast && <div style={{position:"fixed",bottom:24,right:24,zIndex:9999,
        background:toast.ok?"var(--success)":"var(--danger)",color:"#fff",
        padding:"12px 20px",borderRadius:8,fontWeight:600,fontSize:13}}>{toast.msg}</div>}

      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <div style={{fontSize:15,fontWeight:700,color:"var(--text-main)"}}>Performance Fee Invoices</div>
        <button onClick={load} style={{padding:"6px 14px",borderRadius:8,border:"1px solid var(--border)",
          background:"var(--bg-elevated)",color:"var(--text-muted)",fontSize:12,cursor:"pointer"}}>
          Refresh
        </button>
      </div>

      {/* Filter tabs */}
      <div style={{display:"flex",gap:4,marginBottom:14,borderBottom:"1px solid var(--border)"}}>
        {FILTERS.map(f=>(
          <button key={f.v} onClick={()=>setFilter(f.v)}
            style={{padding:"6px 14px",border:"none",cursor:"pointer",fontSize:12,fontWeight:600,
              background:"transparent",marginBottom:-1,
              borderBottom:filter===f.v?"2px solid var(--accent)":"2px solid transparent",
              color:filter===f.v?"var(--accent)":"var(--text-muted)"}}>
            {f.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div style={{padding:32,textAlign:"center",color:"var(--text-muted)"}}>Loading...</div>
      ) : invoices.length === 0 ? (
        <div style={{padding:24,textAlign:"center",color:"var(--text-muted)",fontSize:13}}>
          No invoices found for this filter.
        </div>
      ) : (
        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead>
              <tr style={{borderBottom:"1px solid var(--border)"}}>
                {["Invoice #","Investor","Trader","Month","Amount","Method","Ref","Submitted","Status","Actions"].map(h=>(
                  <th key={h} style={{padding:"8px 10px",textAlign:"left",fontSize:11,fontWeight:700,
                    color:"var(--text-muted)",textTransform:"uppercase",letterSpacing:"0.04em",whiteSpace:"nowrap"}}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {invoices.map((inv,i)=>(
                <tr key={i} style={{borderBottom:"1px solid rgba(255,255,255,0.04)",
                  background:selected===inv.id?"rgba(59,130,246,0.05)":"transparent"}}>
                  <td style={{padding:"10px",fontSize:12,color:"var(--accent)",fontWeight:600}}>
                    {inv.invoice_number}
                  </td>
                  <td style={{padding:"10px",fontSize:12}}>
                    <div style={{fontWeight:600,color:"var(--text-main)"}}>{inv.investor_name}</div>
                    <div style={{fontSize:11,color:"var(--text-muted)"}}>{inv.investor_email}</div>
                  </td>
                  <td style={{padding:"10px",fontSize:12,color:"var(--text-main)"}}>{inv.trader_name}</td>
                  <td style={{padding:"10px",fontSize:12,color:"var(--text-muted)"}}>{inv.billing_month||"—"}</td>
                  <td style={{padding:"10px",fontSize:13,fontWeight:700,color:"var(--warning)"}}>{fmtUSD(inv.total_amount)}</td>
                  <td style={{padding:"10px",fontSize:11,color:"var(--text-muted)",textTransform:"capitalize"}}>
                    {inv.payment_method ? inv.payment_method.replace("_"," ") : "—"}
                  </td>
                  <td style={{padding:"10px",fontSize:11,color:"var(--text-muted)",maxWidth:120,
                    overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                    {inv.payment_ref || "—"}
                  </td>
                  <td style={{padding:"10px",fontSize:11,color:"var(--text-muted)",whiteSpace:"nowrap"}}>
                    {inv.submitted_at || "—"}
                  </td>
                  <td style={{padding:"10px"}}>
                    <Badge s={inv.is_overdue && inv.status==="pending" ? "overdue" : inv.status}/>
                    {inv.rejection_reason && (
                      <div style={{fontSize:10,color:"var(--danger)",marginTop:2,maxWidth:120}}>
                        ↳ {inv.rejection_reason}
                      </div>
                    )}
                  </td>
                  <td style={{padding:"10px"}}>
                    {inv.status==="under_review" && (
                      <div style={{display:"flex",gap:6}}>
                        <button onClick={()=>setAction({type:"confirm",inv})}
                          style={{padding:"4px 10px",borderRadius:6,border:"none",
                            background:"var(--success)",color:"#fff",fontSize:11,
                            fontWeight:700,cursor:"pointer"}}>
                          Confirm
                        </button>
                        <button onClick={()=>{ setAction({type:"reject",inv}); setReason(""); }}
                          style={{padding:"4px 10px",borderRadius:6,
                            border:"1px solid var(--danger)",background:"transparent",
                            color:"var(--danger)",fontSize:11,fontWeight:700,cursor:"pointer"}}>
                          Reject
                        </button>
                      </div>
                    )}
                    {inv.status==="pending" && (
                      <button onClick={()=>setAction({type:"confirm",inv})}
                        style={{padding:"4px 10px",borderRadius:6,border:"none",
                          background:"var(--accent)",color:"#fff",fontSize:11,
                          fontWeight:700,cursor:"pointer"}}>
                        Mark Paid
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Confirm Modal */}
      {action?.type==="confirm" && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:3000,
          display:"flex",alignItems:"center",justifyContent:"center"}}>
          <div style={{background:"var(--bg-surface)",borderRadius:12,padding:24,
            maxWidth:380,width:"100%",border:"1px solid var(--border)"}}>
            <div style={{fontSize:15,fontWeight:700,color:"var(--text-main)",marginBottom:12}}>
              Confirm Payment Received
            </div>
            <div style={{fontSize:13,color:"var(--text-muted)",marginBottom:16}}>
              Confirm invoice <strong style={{color:"var(--text-main)"}}>{action.inv.invoice_number}</strong> — {fmtUSD(action.inv.total_amount)} from <strong style={{color:"var(--text-main)"}}>{action.inv.investor_name}</strong> has been received?
            </div>
            <div style={{display:"flex",gap:8}}>
              <button onClick={()=>setAction(null)}
                style={{flex:1,padding:"10px",borderRadius:8,border:"1px solid var(--border)",
                  background:"var(--bg-elevated)",color:"var(--text-muted)",cursor:"pointer",fontWeight:600}}>
                Cancel
              </button>
              <button onClick={()=>confirmPaid(action.inv)} disabled={working}
                style={{flex:2,padding:"10px",borderRadius:8,border:"none",
                  background:"var(--success)",color:"#fff",fontWeight:700,
                  cursor:"pointer",opacity:working?0.6:1}}>
                {working?"Processing...":"Yes, Confirm Paid"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Reject Modal */}
      {action?.type==="reject" && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:3000,
          display:"flex",alignItems:"center",justifyContent:"center"}}>
          <div style={{background:"var(--bg-surface)",borderRadius:12,padding:24,
            maxWidth:400,width:"100%",border:"1px solid var(--border)"}}>
            <div style={{fontSize:15,fontWeight:700,color:"var(--text-main)",marginBottom:12}}>
              Reject Payment Submission
            </div>
            <div style={{fontSize:12,color:"var(--text-muted)",marginBottom:10}}>
              Invoice {action.inv.invoice_number} akan dikembalikan ke Pending. Investor perlu submit ulang.
            </div>
            <textarea value={reason} onChange={e=>setReason(e.target.value)} rows={3}
              placeholder="Reason for rejection (required)..."
              style={{width:"100%",padding:"10px",background:"var(--bg-elevated)",
                border:"1px solid var(--border)",borderRadius:8,color:"var(--text-main)",
                fontSize:13,outline:"none",resize:"none",boxSizing:"border-box",marginBottom:12}}/>
            <div style={{display:"flex",gap:8}}>
              <button onClick={()=>setAction(null)}
                style={{flex:1,padding:"10px",borderRadius:8,border:"1px solid var(--border)",
                  background:"var(--bg-elevated)",color:"var(--text-muted)",cursor:"pointer",fontWeight:600}}>
                Cancel
              </button>
              <button onClick={()=>rejectInv(action.inv)} disabled={working}
                style={{flex:2,padding:"10px",borderRadius:8,border:"none",
                  background:"var(--danger)",color:"#fff",fontWeight:700,
                  cursor:"pointer",opacity:working?0.6:1}}>
                {working?"Processing...":"Reject & Return to Pending"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
